import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
// import NumberFormat from "react-number-format";
import {
  DataGrid,
  // GridToolbarExport,
  // GridToolbarContainer,
} from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import { Box, IconButton, Button } from "@material-ui/core";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  CloudDownload as CloudDownloadIcon,
} from "@material-ui/icons";
import {
  firstDateOfMonth,
  getPrevMonthDay,
  getNextMonthDay,
  getYearMonthKor,
} from "../calendar";
import { reqSettlement } from "./api";
//import { getBommedExporter } from '../util/sheet';
import FoodangLoading from "../common/components/FoodangLoading";
import { Actions, Resources, useHasPermissions } from "../lib/react-admin-loopback";
import XLSX from 'xlsx-js-style';
import { getYearMonth } from "../calendar";
//const exporter = getBommedExporter('customer');

// 전역 Style
const useStyles = makeStyles((theme) => ({
  paper: {
    // paper 영역 마진 , 텍스트
    textAlign: "center",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

// DataGrid column 설정
const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "업체명", width: 400 },
  { field: "sellAmount", type: "number", headerName: "총매출", width: 130 },
  { field: "fee", type: "number", headerName: "수수료", width: 130 },
  //{ field: 'vat', type: 'number', headerName: '부가세', width: 130 },
  { field: "adjust", type: "number", headerName: "감액", width: 130 },
  { field: "kpi", type: "number", headerName: "KPI", width: 130 },
  { field: "calculated", type: "number", headerName: "정산액", width: 130 },
];

const SupplierSettleList = () => {

  const hasPermission = useHasPermissions(
    Resources.SupplierOrders,
    Actions.List,
    () => {
      alert('권한이 없습니다.');
      history.push('/schedules');
    }
  );

  const hasShowPermission = useHasPermissions(
    Resources.SupplierOrders,
    Actions.Show,
  );

  const history = useHistory();
  const classes = useStyles();
  const [firstDate, setFirstDate] = useState(firstDateOfMonth(new Date()));

  const dataRef = useRef({
    settledata: [], //  정산 data fetched
    revenue: [], // KPI 자료
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // load 정산 자료
        setLoading(true);
        const { data } = await reqSettlement(firstDate);

        dataRef.current.settledata = data.settlement;
        dataRef.current.revenue = data.total;

        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        // LATER server logging
        console.error(err);
      }
    };
    fetchData();
  }, [firstDate]);

  // 이전달
  const handleClickPrev = () => {
    setFirstDate(getPrevMonthDay(firstDate));
  };

  // 다음달
  const handleClickNext = () => {
    setFirstDate(getNextMonthDay(firstDate));
  };

  const Toolbar = () => {
    return (
      dataRef.current.settledata.length > 0 &&
      <Button
        onClick={() => {excelDown()}}
        startIcon={<CloudDownloadIcon/>}
        color="primary"
        size="small"
      > Excel Download
      </Button>
    )
  };
  
  const excelDown = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(dataRef.current.settledata);
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    XLSX.writeFile(wb, "공급사정산리스트_" + getYearMonth(firstDate) + ".xlsx");
  }

  return (
    <div style={{ height: "100%", width: "100%" }}>
      {loading ? <FoodangLoading /> : null}

      <Paper className={classes.paper}>
        <Box>
          <IconButton aria-label="go to prev" onClick={handleClickPrev}>
            <ChevronLeftIcon />
          </IconButton>
          <span>{getYearMonthKor(firstDate)}</span>
          <IconButton aria-label="go to next" onClick={handleClickNext}>
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Paper>
      <Paper>
        <Box className={classes.root}>
          <TextField
            label="총 매출"
            value={dataRef.current.revenue.calculated ? dataRef.current.revenue.calculated : 0}
            name="calculated"
            id="formatted-numberformat-input"
            InputProps={{
              readOnly: true,
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
          <TextField
            label="총 수수료"
            value={dataRef.current.revenue.fee ? dataRef.current.revenue.fee : 0}
            name="fee"
            id="fee"
            InputProps={{
              readOnly: true,
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
          <TextField
            label="총 KPI"
            value={dataRef.current.revenue.kpi ? dataRef.current.revenue.kpi : 0}
            name="kpi"
            id="formatted-numberformat-input"
            InputProps={{
              readOnly: true,
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
        </Box>
      </Paper>
      <br />
      <DataGrid
        rows={dataRef.current.settledata}
        columns={columns}
        pageSize={30}
        onRowClick={(row) => {
          if (hasShowPermission) {
            history.push(
              `/supplier/settlement?id=${row.row.id}&name=${row.row.name}`
            );
          }
        }}
        components={{
          Toolbar: Toolbar,
        }}
      />
    </div>
  );
};

// const Toolbar = () => (
//   <GridToolbarContainer>
//     <GridToolbarExport 
//       csvOptions={{
//         fileName: '공급사정산리스트',
//         utf8WithBom: true,
//       }}
//     />
//   </GridToolbarContainer>
// );

export default SupplierSettleList;
